import React from 'react';
import styles from './DateEntityConfig.scss';

const DateEntityConfig = () => {
  return (
    <div className={styles.container}>
      <div className={styles.title}>How to use DATE Type entity?</div>
      <div className={styles.subtitle}>
        Date entity can detect the following things:
      </div>
      <div className={styles.group}>
        <div className={styles.head}>Date format</div>
        <div className={styles.row}>
          <div className={styles.key}>dd/mm/yy</div>
          <div className={styles.value}>Eg: Book me a flight on 22/01/2018</div>
        </div>
        <div className={styles.row}>
          <div className={styles.key}>dd.mm.yy</div>
          <div className={styles.value}>Eg: Set a reminder on 12.3.18</div>
        </div>
        <div className={styles.row}>
          <div className={styles.key}>yy-mm-dd</div>
          <div className={styles.value}>Eg: Whats the day on 2018.12.1 ?</div>
        </div>
        <div className={styles.row}>
          <div className={styles.key}>d mm yyyy</div>
          <div className={styles.value}>
            Eg: Set a meeting reminder on 2 jan 2018
          </div>
        </div>
      </div>

      <div className={styles.group}>
        <div className={styles.head}>Day and Month</div>
        <div className={styles.row}>
          <div className={styles.key}>dd mm</div>
          <div className={styles.value}>Eg: Set an alarm on 2 Jan</div>
        </div>
        <div className={styles.row}>
          <div className={styles.key}>mm dd</div>
          <div className={styles.value}>Eg: Set a reminder on March 9</div>
        </div>
      </div>

      <div className={styles.group}>
        <div className={styles.head}>Days</div>
        <div className={styles.row}>
          <div className={styles.key}>Days of the week</div>
          <div className={styles.value}>
            Eg: Set a meeting for this Tuesday.
          </div>
        </div>
        <div className={styles.row}>
          <div className={styles.key}>Upcoming days</div>
          <div className={styles.value}>
            Eg: Book a table for the coming Monday.
          </div>
        </div>
        <div className={styles.row}>
          <div className={styles.key}>After/Before</div>
          <div className={styles.value}>
            Eg: Wake me up on the day after tomorrow.
          </div>
        </div>
        <div className={styles.row}>
          <div className={styles.key}>Day of a month</div>
          <div className={styles.value}>
            Eg: Remind me to pay bills on 18th of May.
          </div>
        </div>
      </div>
    </div>
  );
};

export default DateEntityConfig;
